import Counter from '../../../internal/platformMetrics/aggregators/Counter';
export const safeParams = [
    'dashboard_banners'
];
export default new Counter('frontend.platform-ui.banner-count');

//# sourceMappingURL=bannerCount.js.map